import PageLayout from "@/components/PageLayout";
import Gallery from "@/components/Gallery";
import SEO from "@/components/SEO";

export default function GalleryPage() {
  return (
    <PageLayout>
      <SEO
        title="Shade Charts & Store Gallery | Mutha Paras & Co. Lining Fabrics"
        description="Browse all 446 American Crepe shades, lining shade charts, and our Chickpet showroom. Pick your shade number and order directly on WhatsApp."
        path="/gallery"
      />
      <Gallery />
    </PageLayout>
  );
}
